export default {
  title: 'Nom d\'utilisateur',
  label: 'Formats à respecter :',
  case1: '8 caractères ou plus',
  case2: 'Différent de votre mot de passe',
  case3: 'Différent du nom d\'utilisateur d\'un autre compte',
  formatError: 'Le nom d\'utilisateur ne respecte pas le format attendu.',
};
